import { useTranslation } from "react-i18next";
import { TABLE_HEADERS } from "../constants";
import styles from "./styles.module.scss";
import { useEffect, useMemo, useState } from "react";
import { AlertColor } from "@mui/material";
import CustomizedSnackbars from "../../../components/common/customizedSnackbars";
import { ROUTES } from "../../../setup/constants";
import {
  MultiCashoutItem,
  MultiCashoutPaymentItem,
} from "../../../setup/api/services/multiCashouts/models";

interface IRowItem {
  userId: string;
  userName: string;
  numberOfTransactions: number;
  amount: number;
}
interface IMultiCashoutsListItem {
  multiCashoutItem: MultiCashoutItem | MultiCashoutPaymentItem;
}

const MultiCashoutsListItem = ({
  multiCashoutItem,
}: IMultiCashoutsListItem) => {
  const { t } = useTranslation();

  const [snackBarOpen, setSnackBarOpen] = useState<boolean>(false);
  const [snackBarColor, setSnackBarColor] = useState<AlertColor>("info");
  const [snackBarTitle, setSnackBarTitle] = useState<string>("");

  const createRow = (desc: string, value) => {
    return { desc, value };
  };

  const isMultiCashoutPaymentItem =
    "beneficiaryId" in multiCashoutItem && "status" in multiCashoutItem;

  const rowItem: IRowItem = useMemo(() => {
    if (isMultiCashoutPaymentItem) {
      return {
        userId: multiCashoutItem.beneficiaryId.toString(),
        userName: multiCashoutItem.beneficiaryName,
        numberOfTransactions: multiCashoutItem.numberOfTransactions,
        amount: multiCashoutItem.amount,
      };
    } else {
      return {
        userId: multiCashoutItem.userId,
        userName: multiCashoutItem.userName,
        numberOfTransactions: multiCashoutItem.numberOfPendingTransfers,
        amount: multiCashoutItem.amount,
      };
    }
  }, [isMultiCashoutPaymentItem, multiCashoutItem]);

  const handleRowClick = () => {
    if (isMultiCashoutPaymentItem) {
      window.open(`${ROUTES.WITHDRAWS}/${multiCashoutItem.id}`, "_blank");
    } else {
      window.open(`${ROUTES.MULTI_CASHOUTS}/${rowItem.userId}`, "_blank");
    }
  };

  const rows = [
    createRow(
      TABLE_HEADERS.USER_NAME,
      <div className={styles["transaction_name"]} onClick={handleRowClick}>
        <p dir="rtl">{rowItem.userName}</p>
      </div>
    ),
    createRow(
      TABLE_HEADERS.CASHOUTS_NUMBER,
      <div className={styles["transaction_id"]}>
        <p dir="rtl">{rowItem.numberOfTransactions || ""}</p>
      </div>
    ),
    createRow(
      TABLE_HEADERS.TOTAL_AMOUNT,
      <div className={styles["cashouts_number"]}>
        <p dir="rtl">{rowItem.amount + " " + t("lbl_saudi_currency")}</p>
      </div>
    ),
  ];

  useEffect(() => {
    if (snackBarOpen) {
      setTimeout(() => {
        setSnackBarOpen(false);
        setSnackBarColor("info");
        setSnackBarTitle("");
      }, 5000);
    }
  }, [snackBarOpen]);

  const renderSnackBar = () => {
    return snackBarOpen ? (
      <CustomizedSnackbars
        open={snackBarOpen}
        title={snackBarTitle}
        type={snackBarColor}
      />
    ) : null;
  };

  return (
    <>
      <tr className={styles.table_row}>
        {rows.map((row, index) => (
          <td className={styles.table_value} key={index}>
            {row.value}
          </td>
        ))}
      </tr>
      {renderSnackBar()}
    </>
  );
};

export default MultiCashoutsListItem;
